<template>
  <div :class="componentClassName">
    <template v-for="(item, index) in currentSettingList" :key="index">
      <m-response-flow-item
        v-model="currentSettingList[index].active"
        :item-index="index"
        :label="'プッシュ番号 ' + (index + 1)"
        :setting-name="currentSettingList[index].settingName"
        :response-mode="currentSettingList[index].responseMode"
        :value="currentSettingList[index].value"
        :voice-d-x-phone-number-list="voiceDXPhoneNumberList"
        :view-only="viewOnly"
        @change="handleSettingChange"
        @config="handleConfig"
      />
    </template>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import MResponseFlowItem from '@/components/molecules/response-flow-item';
import { cloneDeep } from 'lodash';

export default {
  name: 'o-response-flow-setting-list',
  components: {
    MResponseFlowItem,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    settingList: {
      type: Array,
      default: new Array(0),
    },
    modelValue: {
      type: Array,
      default: null,
    },
    voiceDXPhoneNumberList: {
      type: Array,
      default: new Array(0),
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'update:modelValue', 'config'],
  data() {
    return {
      maxItems: 5,
      currentSettingList: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-response-flow-setting-list');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    settingList: {
      handler(val) {
        this.setCurrentValue(val);
      },
      deep: true,
    },
    modelValue: {
      handler(val) {
        this.setCurrentValue(val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.settingList) {
      this.setCurrentValue(this.settingList);
    }
    if (this.modelValue) {
      this.setCurrentValue(this.modelValue);
    }
  },
  methods: {
    setCurrentValue(items) {
      this.currentSettingList.splice(0);
      if (Array.isArray(items)) {
        let itemMaxCount = this.maxItems;
        if (items.length < itemMaxCount) {
          itemMaxCount = items.length;
        }
        // maximum of 5 items
        for (let i = 0; i < itemMaxCount; i += 1) {
          this.currentSettingList.push(items[i]);
        }
      }
      if (this.currentSettingList.length < this.maxItems) {
        // populate
        for (let p = this.currentSettingList.length; p < this.maxItems; p += 1) {
          this.currentSettingList.push({
            active: false,
            settingName: '',
            responseMode: null,
            value: '',
            users: [],
          });
        }
      }
    },
    handleSettingChange() {
      this.$emit('update:modelValue', cloneDeep(this.currentSettingList));
      this.$emit('change', cloneDeep(this.currentSettingList));
    },
    handleConfig(itemIndex) {
      this.$emit('config', itemIndex);
    },
  },
};
</script>
